import { ColumnGroupPropsWithChildren } from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ColumnGroup = (props: ColumnGroupPropsWithChildren) => {
  return null;
};
